function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1972(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 6.25,
    height: 5.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.8983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 2.695
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.39,
    width: 6.25,
    height: 12.4,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 11.59
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.79,
    width: 6.25,
    height: 26.21,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 30.895
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 44,
    width: 6.25,
    height: 33.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 60.695
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 77.39,
    width: 6.25,
    height: 34.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.8928571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 94.625
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 111.86,
    width: 6.25,
    height: 35.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.78125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 129.555
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 147.25,
    width: 6.25,
    height: 44.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 169.335
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 191.42,
    width: 6.25,
    height: 52.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.6944444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 217.86499999999998
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 244.31,
    width: 6.25,
    height: 59.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 274.09000000000003
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 303.87,
    width: 6.25,
    height: 61.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 334.85
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 365.83,
    width: 6.25,
    height: 63.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.6944444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 397.57
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 429.31,
    width: 6.25,
    height: 64.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 461.53
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 493.75,
    width: 6.25,
    height: 66.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 527.1
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 560.45,
    width: 6.25,
    height: 67.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 593.97
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 627.49,
    width: 6.25,
    height: 72.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.125,
    y: 663.745
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 0,
    width: 39.34,
    height: 16.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 25.92,
    y: 8.08
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.6,
    y: 0,
    width: 42.15,
    height: 16.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.675,
    y: 8.08
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.75,
    y: 0,
    width: 42.58,
    height: 16.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.03999999999999,
    y: 8.08
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.33,
    y: 0,
    width: 45.03,
    height: 16.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.84500000000003,
    y: 8.08
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.36,
    y: 0,
    width: 53.05,
    height: 16.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.88500000000002,
    y: 8.08
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.41,
    y: 0,
    width: 53.26,
    height: 16.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.04,
    y: 8.08
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.67,
    y: 0,
    width: 53.97,
    height: 16.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.65500000000003,
    y: 8.08
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.64,
    y: 0,
    width: 59.34,
    height: 16.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.31,
    y: 8.08
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.98,
    y: 0,
    width: 67.39,
    height: 16.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.232
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.675,
    y: 8.08
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.37,
    y: 0,
    width: 75.76,
    height: 16.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7955555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 500.25,
    y: 8.08
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.13,
    y: 0,
    width: 79.06,
    height: 16.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7955555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.66,
    y: 8.08
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 617.19,
    y: 0,
    width: 82.81,
    height: 16.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.595,
    y: 8.08
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 16.16,
    width: 51.27,
    height: 37.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 34.805
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 53.44,
    width: 51.27,
    height: 40.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.776666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 73.77
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 94.11,
    width: 51.27,
    height: 42.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.031666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 115.205
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 136.3,
    width: 51.27,
    height: 44.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 158.72000000000003
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 181.14,
    width: 51.27,
    height: 48.81,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.2025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 205.545
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 229.95,
    width: 51.27,
    height: 52.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.40875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 256.085
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 282.22,
    width: 51.27,
    height: 57.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.254000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 310.79
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 339.36,
    width: 51.27,
    height: 58.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.418
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 368.5
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 397.64,
    width: 51.27,
    height: 66.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 430.74
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 463.84,
    width: 51.27,
    height: 68.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 498.19
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 532.54,
    width: 51.27,
    height: 79.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.127000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 572.375
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 612.21,
    width: 51.27,
    height: 87.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.127000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.885,
    y: 656.105
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.52,
    y: 16.16,
    width: 55.65,
    height: 86.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.95625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.345,
    y: 59.519999999999996
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.17,
    y: 16.16,
    width: 70.15,
    height: 86.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.030000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.245,
    y: 59.519999999999996
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.32,
    y: 16.16,
    width: 71.2,
    height: 86.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.92,
    y: 59.519999999999996
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.51,
    y: 16.16,
    width: 75.27,
    height: 86.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.842727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.145,
    y: 59.519999999999996
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.78,
    y: 16.16,
    width: 80.49,
    height: 86.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.1225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.025,
    y: 59.519999999999996
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.27,
    y: 16.16,
    width: 82.07,
    height: 86.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.313076923076922
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.30499999999995,
    y: 59.519999999999996
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.34,
    y: 16.16,
    width: 101.83,
    height: 86.72,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.388571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.255,
    y: 59.519999999999996
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.17,
    y: 16.16,
    width: 105.83,
    height: 86.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.0849999999999,
    y: 59.519999999999996
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.52,
    y: 102.88,
    width: 120.63,
    height: 90.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.054444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.83500000000001,
    y: 148.125
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.52,
    y: 193.36,
    width: 120.63,
    height: 117.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.83500000000001,
    y: 252.16000000000003
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.52,
    y: 310.97,
    width: 120.63,
    height: 124.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.403333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.83500000000001,
    y: 373.18
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.52,
    y: 435.38,
    width: 120.63,
    height: 124.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.0525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.83500000000001,
    y: 497.73
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.52,
    y: 560.09,
    width: 120.63,
    height: 139.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.062999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.83500000000001,
    y: 630.0450000000001
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.15,
    y: 102.88,
    width: 128.96,
    height: 138.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.63,
    y: 172.075
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.11,
    y: 102.88,
    width: 193.5,
    height: 138.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.58090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.86,
    y: 172.075
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.62,
    y: 102.88,
    width: 199.38,
    height: 138.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.31,
    y: 172.075
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.15,
    y: 241.26,
    width: 160.56,
    height: 219.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.43,
    y: 350.885
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.15,
    y: 460.51,
    width: 160.56,
    height: 239.49,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.43,
    y: 580.255
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.71,
    y: 241.26,
    width: 361.29,
    height: 458.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.844545454545454
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.355,
    y: 470.63
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1972);
export default __webpack_public_path__ + "static/media/1972.5bd72d684e93ad1580a04557814229a5.svg";
export { ForwardRef as ReactComponent };